import React, { forwardRef, useEffect } from "react";
//#region components
import { useGrossSalaryChangeContext } from "../context/useGrossSalaryChangeContext";
//#endregion

interface ZeroGrossSalaryChangeContentProps {
  children: React.ReactNode;
  onFormValidationChange?: (isValid: boolean) => void;
}

const ZeroGrossSalaryChangeContent = forwardRef<HTMLDivElement, ZeroGrossSalaryChangeContentProps>(
  ({ children, onFormValidationChange }, ref) => {
    const { loading, personData } = useGrossSalaryChangeContext();

    useEffect(() => {
      onFormValidationChange?.(!loading && personData !== undefined);
    }, [loading, personData, onFormValidationChange]);

    return <div ref={ref}>{children}</div>;
  }
);

export default ZeroGrossSalaryChangeContent;
